var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedirectIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.11401 9.88525L9.88534 6.11458M9.88534 6.11458H6.58534M9.88534 6.11458V9.41458M8.00001 14.6666C11.682 14.6666 14.6667 11.6819 14.6667 7.99992C14.6667 4.31792 11.682 1.33325 8.00001 1.33325C4.31801 1.33325 1.33334 4.31792 1.33334 7.99992C1.33334 11.6819 4.31801 14.6666 8.00001 14.6666Z",
    stroke: "#5070DE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectIcon);
export default __webpack_public_path__ + "static/media/redirectIcon.680bd369ee8cae0c05511740f7438b42.svg";
export { ForwardRef as ReactComponent };